import * as React from "react";
import { baseUrl } from "../../services/setup";
import Paper from "@mui/material/Paper";
import "../admin/css/style.css";
import {
  MDBBtn,
  MDBCardBody,
  MDBCardText,
  MDBCol,
  MDBInput,
  MDBRow,
} from "mdb-react-ui-kit";
import { useState } from "react";
import request from "superagent";
import { loader } from "../LoadingSpinner.js";
import Swal from "sweetalert2";
import { Toast } from "../errorNotifier.js";

export default function SiteAdminTab() {
  const [stdId, setStdId] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [pictureRstEmail, setPictureRstEmail] = useState("");
  const [bypassEmailState, setBypassEmailState] = useState("");
  const [isBypassing, setIsBypassing] = useState(false);

  const handleApproveBypass = async () => {
    if (!navigator.onLine) {
      Toast.fire({ icon: "error", title: "No internet connection" });
      return;
    }
    if (!bypassEmailState) {
      Toast.fire({ icon: "error", title: "Please enter applicant email" });
      return;
    }

    setIsBypassing(true);
    loader({ title: "Approving", text: "Please wait..." });
    const token = localStorage.getItem("token") || localStorage.getItem("adminToken");

    try {
      const response = await request
        .post(`${baseUrl}nin_verification/approve_bypass`)
        .set("Authorization", `Bearer ${token}`)
        .send({ email: bypassEmailState })
        .type("application/json");

      Toast.fire({ icon: "success", title: "Bypass approved successfully" });
      setBypassEmailState("");
    } catch (err) {
      console.log(err);
      let errorText = err.response?.text || err.message || "Failed to approve bypass";
      Swal.fire({ title: "Error!", text: errorText, icon: "error" });
    } finally {
      setIsBypassing(false);
    }
  };

  const resetUserPassword = async () => {
    if (navigator.onLine) {
      // progress spinner
      loader({
        title: "Resetting",
        text: "Please! wait.",
      });

      if (resetEmail === "") {
        Toast.fire({
          icon: "error",
          title: "Please! enter email",
        });
        return;
      }

      const data = { Email: resetEmail };

      await request
        .post("https://api.mcchstfuntua.edu.ng/admin/user_password_reset.php")
        .type("application/json")
        .send(data)
        .then((response) => {
          Toast.fire({
            icon: "success",
            title: "Resetted successfully",
          });

          setResetEmail("");
        })
        .catch((err) => {
          let errorText = err.response.text;
          console.log(errorText);

          Swal.fire({
            title: "Error!",
            text: errorText,
            icon: "error",
          });
        });
    } else {
      Toast.fire({
        icon: "error",
        title: "No internet connection",
      });
    }
  };

  const resetStdPicture = async () => {
    if (navigator.onLine) {
      if (pictureRstEmail === "") {
        Toast.fire({
          icon: "error",
          title: "Please! enter email",
        });
        return;
      }

      // progress spinner
      loader({
        title: "Resetting",
        text: "Please! wait...",
      });

      const data = { Email: pictureRstEmail };

      await request
        .post("https://api.mcchstfuntua.edu.ng/uploads/reset_image.php")
        .type("application/json")
        .send(data)
        .then((response) => {
          console.log("RESPONSE", response.body);

          Toast.fire({
            icon: "success",
            title: "Resetted successfully",
          });

          setPictureRstEmail("");
        })
        .catch((err) => {
          let errorText = err.response.text;
          console.log(errorText);

          Swal.fire({
            title: "Error!",
            text: errorText,
            icon: "error",
          });
        });
    } else {
      Toast.fire({
        icon: "error",
        title: "No internet connection",
      });
    }
  };

  const resetUserEmail = async () => {
    console.log("COURSES ON OFFER", resetEmail);

    if (navigator.onLine) {
      // progress spinner
      loader({
        title: "Resetting",
        text: "Please! wait.",
      });

      const data = { Email: resetEmail };

      await request
        .post("https://api.mcchstfuntua.edu.ng/admin/user_email_reset.php")
        .type("application/json")
        .send(data)
        .then((response) => {
          Toast.fire({
            icon: "success",
            title: "Resetted successfully",
          });

          setResetEmail("");
        })
        .catch((err) => {
          let errorText = err.response.text;
          console.log(errorText);

          Swal.fire({
            title: "Error!",
            text: errorText,
            icon: "error",
          });
        });
    } else {
      Toast.fire({
        icon: "error",
        title: "No internet connection",
      });
    }
  };

  return (
    <div className="m-4 d-flex flex-column align-items-center">
      <MDBCardBody>
        <MDBCardText>
          <h4>Site Management</h4>
        </MDBCardText>
      </MDBCardBody>
      <Paper className="p-2 my-2 w-100">
        <div style={{ fontWeight: "900", padding: "20px" }}>
          User Password Reset
        </div>

        <MDBRow>
          <MDBCol>
            <div className="d-flex align-items-center">
              <MDBInput
                label="Reset email"
                value={resetEmail}
                type="text"
                onChange={(e) => {
                  setResetEmail(e.target.value);
                }}
                size="lg"
              />

              <MDBBtn
                className="w-25"
                size="lg"
                style={{ background: "#05321e" }}
                onClick={resetUserPassword}
              >
                Reset Password
              </MDBBtn>
            </div>
          </MDBCol>
        </MDBRow>
      </Paper>

      <Paper className="p-2 my-2 w-100">
        <div style={{ fontWeight: "900", padding: "20px" }}>
          Reset Student picture
        </div>

        <MDBRow>
          <MDBCol>
            <div className="d-flex align-items-center">
              <MDBInput
                label="Picture Reset email"
                value={pictureRstEmail}
                type="text"
                onChange={(e) => {
                  setPictureRstEmail(e.target.value);
                }}
                size="lg"
              />

              <MDBBtn
                className="w-25"
                size="lg"
                style={{ background: "#05321e" }}
                onClick={resetStdPicture}
              >
                Reset Picture
              </MDBBtn>
            </div>
          </MDBCol>
        </MDBRow>
      </Paper>

      <Paper className="p-2 my-2 w-100">
        <div style={{ fontWeight: "900", padding: "20px" }}>
          Change student email
        </div>

        <MDBRow>
          <MDBCol>
            <div className="d-flex align-items-center">
              <MDBInput
                className="mb-2"
                label="Application id or phone number"
                value={stdId}
                type="text"
                onChange={(e) => {
                  setStdId(e.target.value);
                }}
                size="lg"
              />
            </div>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <MDBInput
              className="mt-2"
              label="New email"
              value={newEmail}
              type="text"
              onChange={(e) => {
                setNewEmail(e.target.value);
              }}
              size="lg"
            />

            <MDBBtn
              className="w-50"
              size="lg"
              style={{ background: "#05321e" }}
              // onClick={resetUserPassword}
            >
              Reset
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </Paper>
      <Paper className="p-2 my-2 w-100">
        <div style={{ fontWeight: "900", padding: "20px" }}>
          NIN Verification Bypass
        </div>
        <div style={{ padding: "0 20px 10px 20px", color: "#666" }}>
          Approve NIN bypass for a specific applicant email. This allows them to use their existing profile information.
        </div>
        <MDBRow>
          <MDBCol>
            <div className="d-flex align-items-center mb-3 px-3">
              <MDBInput
                label="Applicant Email"
                value={bypassEmailState}
                type="text"
                onChange={(e) => {
                  setBypassEmailState(e.target.value);
                }}
                size="lg"
              />

              <MDBBtn
                className="w-25 ms-3"
                size="lg"
                style={{ background: "#c0392b" }}
                onClick={handleApproveBypass}
                disabled={!bypassEmailState || isBypassing}
              >
                {isBypassing ? "Approving..." : "Approve Bypass"}
              </MDBBtn>
            </div>
          </MDBCol>
        </MDBRow>
      </Paper>
    </div>
  );
}
